// Module
var code = `<template>
  <require from="../report-grid.scss"></require>
  <require from="./profit-loss-report.scss"></require>

  <div class="profit-loss-report">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>

    <div if.bind="!loading && !error" class="mdc-report-layout-grid">
      <mdc-layout-grid-inner class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
          <div class="mdc-report-sum-grid balance-sheet report-heading-row">
            <div class="mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.lYReportDate | dateConverter}</div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.yTDReportDate | dateConverter}</div>
            </div>
          </div>
        </div>


        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Operating income</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYOperatingIncome | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDOperatingIncome | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Personell expenses</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYPersonellExpenses | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDPersonellExpenses | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Other operating expenses</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYOtherOperatingExpenses | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDOtherOperatingExpenses | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
          <div class="mdc-report-sum-grid report-sum-row">
            <div class="mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
                Operating profit</div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.lYOperatingProfit | numericFormatter:'zeroDec'}</div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.yTDOperatingProfit | numericFormatter:'zeroDec'}</div>
            </div>
          </div>
        </div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Net Interest</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYNetInterest | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDNetInterest | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Change In Value</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYChangeInValueYtd | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDChangeInValueYtd | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Net sold securities</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYNetSoldSecurities | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDNetSoldSecurities | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Dividend</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYDividend | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDDividend | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Net Currency</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYNetCurrency | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDNetCurrency | numericFormatter:'zeroDec'}</div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Other financial items</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYOtherFinItems | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDOtherFinItems | numericFormatter:'zeroDec'}</div>



        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
          <div class="mdc-report-sum-grid report-sum-row">
            <div class="mdc-layout-grid__inner">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
                Net financial items</div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.lYNetFinancialItems | numericFormatter:'zeroDec'}</div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
                \${data.yTDNetFinancialItems | numericFormatter:'zeroDec'}</div>
            </div>
          </div>
        </div>

        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone">
          Net income (before tax)</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.lYNetIncomeBeforeTax | numericFormatter:'zeroDec'}</div>
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-tablet mdc-layout-grid__cell--span-3-phone pull-right">
          \${data.yTDNetIncomeBeforeTax | numericFormatter:'zeroDec'}</div>
      </mdc-layout-grid-inner>
    </div>

    <message if.bind="error" icon="error" colour="mdc-theme--error" class="profit-loss-report__error">
      \${error.message}</message>
  </div>
</template>
`;
// Exports
export default code;